/**
 * @param {Element} element element to hide
 */
export const hideElement = (element, byOpacity = true, noSpace = false, noTransition = false) => {
	if (element) {
		let transitionBkp = '';
		if (noTransition) {
			transitionBkp = element.style.transition;
			element.style.transition = 'unset';
		}

		element.classList.add('dpit-hidden');
		if (!byOpacity) element.classList.add('dpit-hidden--by-disp');
		if (noSpace) element.classList.add('dpit-hidden--no-space');

		if (noTransition) {
			setTimeout(() => {
				element.style.transition = transitionBkp;
			}, 50);
		}
	}
};

/**
 * @param {Element} element element to hide
 */
export const hideElementImmediately = (element, byOpacity = true, noSpace = false) => {
	hideElement(element, byOpacity, noSpace, true);
};

/**
 * @param {Element} element element to hide
 */
export const showElement = (element) => {
	if (element) {
		element.classList.remove('dpit-hidden', 'dpit-hidden--no-space', 'dpit-hidden--by-disp', 'dpit-hidden-keep-events');
	}
};